import React, {Component} from 'react';
import './CustomerOrderTable.css';
import CustomerOrderTableHeader from "../CustomerOrderTableHeader/CustomerOrderTableHeader";
import CustomerOrderTableRow from "../CustomerOrderTableRow/CustomerOrderTableRow";
import CustomerOrderTableBottom from "../CustomerOrderTableBottom/CustomerOrderTableBottom";
import {RESOURCE_BASE_URL, ITEM_COUNT_PER_PAGE, BASE_URL} from "../../../../../configuration";
import axios from "axios";
import {FormattedMessage} from "react-intl";

class CustomerOrderTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: this.props.userId,
            orders: [],
            totalItemCount: 0,
            activePage: 1,
            batchNumberSearchText: "",
            page: 0,
            size: ITEM_COUNT_PER_PAGE,
            reorderParams: {},
            checkedReorderItems: [],
            reorderItemSummary: {},

        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.getAllOrders = this.getAllOrders.bind(this);
        this.getAllOrdersByBatchNumber = this.getAllOrdersByBatchNumber.bind(this);

    }

    deleteReorderCartItems = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.post(RESOURCE_BASE_URL + 'api/users/' + localStorage.getItem("userId") +
            '/reorder/items/delete', this.state.checkedReorderItems, axiosConfig)
            .then((res) => {
                // console.log("DELETED STATUS DUO ====> ", res.data);
                this.props.getCartItems();
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    };


    componentDidMount() {
        // console.log("============url api call "+RESOURCE_BASE_URL + 'api/users/' + this.props.userId +'/reorder/items/delete')
        if (this.props.userData && this.props.userId) {
            this.getAllOrders(this.state.page, this.state.size);
        }
        //this.getAllOrders(this.state.page, this.state.size);
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId});
            this.getAllOrders(this.state.page, this.state.size);
        }
    }

    handlePageChange = (pageNumber) => {
        // console.log("PAGE NUMBER DUO ORDER ====> ", pageNumber);
        this.setState({activePage: pageNumber});

        let offset = (pageNumber - 1) * this.state.size;
        // console.log("OFFSET DUO ORDER ====> ", offset);
        this.setState({
            page: pageNumber - 1
        }, () => this.getAllOrders(this.state.page, this.state.size))
    };

    getAllOrders = (offset, limit) => {

        let orderResourceUrl = RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/orders?offset=' + offset + '&limit=' + limit;
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
            }
        };

        axios.get(orderResourceUrl, axiosConfig)
            .then((res) => {
                // console.log("ORDER DATA DUO with reorder ====> ", res.data);
                let reorderObjects = {...this.state.reorderParams};
                res.data.reorderParams.forEach(param => {
                    reorderObjects[param.itemUUID] = param
                });

                // console.log("REORDER PARAMS ALL ORDERs ====> ", res.data);
                this.setState({
                    orders: res.data.orders,
                    totalItemCount: res.data.rowCount,
                    reorderParams: reorderObjects

                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                console.log("Token invalid");
                localStorage.clear();
                window.location.replace(BASE_URL + "login");
            });
    };

    getAllOrdersByBatchNumber = (offset, limit) => {

        let orderResourceUrl = RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/orders/' + this.state.batchNumberSearchText;
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
            }
        };
        if (this.state.batchNumberSearchText !== '') {
            axios.get(orderResourceUrl, axiosConfig)
                .then((res) => {
                    this.setState({
                        orders: res.data,
                        totalItemCount: res.data.rowCount
                    });

                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                });
        }
        if (this.state.batchNumberSearchText === '') {
            this.getAllOrders(this.state.page, this.state.size);
        }

    };

    handleSearchChange = (event) => {
        this.setState({
            batchNumberSearchText: event.target.value
        }, () => this.getAllOrdersByBatchNumber(this.state.page, this.state.size))
    };

    render() {
        let no = 1 + ((this.state.activePage - 1) * 1);


        return (
            <div className="container-fluid">

                <CustomerOrderTableHeader handleSearchChange={this.handleSearchChange}/>

                {this.state.orders.length === 0 &&
                <div className="center-align">
                    <h5>
                        <FormattedMessage id="app.order.history.table.no-records"
                                          defaultMessage="You have no orders yet"
                                          description=""/>
                    </h5>
                </div>
                }
                {this.state.orders.length > 0 &&
                <div>
                    {
                        this.state.orders !== [] || this.state.orders.length !== 0 ?
                            this.state.orders.map(order => {
                                return <CustomerOrderTableRow key={order.id} no={no++} order={order}
                                                              deleteReorderCartItems={this.deleteReorderCartItems}
                                                              userId={this.props.userId}
                                                              getCartItems={this.props.getCartItems}/>
                            }) :
                            <div className="text-center">
                                <FormattedMessage id="app.order.all.no-records"
                                                  defaultMessage="No Records Found" description=""/>
                            </div>
                    }
                    {this.state.batchNumberSearchText === "" ?
                        <CustomerOrderTableBottom activePage={this.state.activePage}
                                                  itemsCountPerPage={ITEM_COUNT_PER_PAGE}
                                                  searchText={this.state.batchNumberSearchText}
                                                  totalItemsCount={this.state.totalItemCount}
                                                  handlePageChange={this.handlePageChange}/> : ""
                    }
                </div>

                }


            </div>
        );
    }

}

export default CustomerOrderTable;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderHistory/CustomerOrderTable/CustomerOrderTable.js